import commonActions from "../../common/actions";

export default async (store, action) => {
  store.dispatch(commonActions.unlock());
};
